;(function ( $ ) {

    /**
     *  confirm
     *  show custom confirmation dialog
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'alertbox';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {

        init: function () {
            console.log('init alertbox');
            var elem = this.element;
            setTimeout(function (){
                console.log('timeout',elem);
                $(elem).addClass('hide');
            }, 1500);
        },

        registerEvents: function() {
            var _this = this;
        },

    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
